import blur_top_right from '../assets/images/blur_top_right.png';
import app_icon from '../assets/images/app_icon.png';

const images = {
	blur_top_right,
	app_icon,
};

export default images;
